// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.success-aa1{\n  background: #F6FFF6;\n  border: 1px solid #CAEFDC;\n}\n.error-aa1 .el-message__content{\n   color: #FF0000 !important;\n}\n", ""]);
// Exports
module.exports = exports;
